
@if(show) {
  <div class="overlay">
    <div class="center">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}